import { render, staticRenderFns } from "./ListMobile.vue?vue&type=template&id=6dca6da6&scoped=true"
import script from "./ListMobile.vue?vue&type=script&lang=ts"
export * from "./ListMobile.vue?vue&type=script&lang=ts"
import style0 from "./ListMobile.vue?vue&type=style&index=0&id=6dca6da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca6da6",
  null
  
)

export default component.exports